<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#users-s"></use></svg>
  Imiter bruger under {{ organization.name }}
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
<mat-dialog-content>
  <p>
    Du kan nu imitere organisationen, <em>{{ this.organization.name }}.</em>
  </p>
  <p>
    Ved klik på nedenstående knap åbnes der en ny browser og her skal du så logge ind igen. Herefter vil du kunne tilgå ladepartner portalen
    lige som en bruger under <em>{{ this.organization.name }}</em> ser den.
  </p>

  @if (!imitationSession && !imitationSuccess) {
    <ok-feedback-fail>
      Imitering mislykkedes. Det skyldes muligvis, at '{{ this.organization.name }}' ikke findes i Auth0
    </ok-feedback-fail>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close type="button" mat-button>Luk</button>
  <button type="button" [class.loading]="loading$ | async" mat-raised-button color="primary" (click)="goToPublicPortal()">
    Gå til {{ publicPortalName }} for {{ organization.name }}
  </button>
</mat-dialog-actions>
